// Centralized help/support destinations (ENG-390 — Zendesk -> kb.spri.ng).
//
// Creator-facing help center now points at the new knowledge base
// (kb.spri.ng/creators).
//
// Still on Zendesk (deliberately): contactNewRequest (the "submit a request"
// ticket form — kb has no equivalent; pending the support-intake decision).
// creatorResources is the spri.ng marketing site, not Zendesk — unchanged.

export const SUPPORT_URLS = {
  helpCenterCreator: 'https://kb.spri.ng/creators',
  contactNewRequest: 'https://spring4creators.zendesk.com/hc/en-us/requests/new',
  creatorSupportHome: 'https://kb.spri.ng/creators',
  // spri.ng creator-resources marketing surface. Base only — callers append the
  // article slug (and any UTM params) to preserve today's exact URLs.
  creatorResources: 'https://www.spri.ng/creator-resources',
} as const;
